module.exports = __webpack_public_path__ + "img/logo.e3ffb20f.svg";